import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const ProductLicenseDetailsContainer = styled(Box)`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: ${theme.spacing.small}px;
  margin-top: ${theme.spacing.medium}px;

  .product-license-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .header-title {
      color: ${theme.colors.menuItemText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0.1px;
    }
  }

  .license-details-heading {
    color: ${theme.colors.foreground};
    font-family: Quicksand, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.1px;
    margin-top: 8px;
  }
`
